import type * as lazyFullOption from "./lazyFullOption";
import type { LazyOption } from "owa-options-core";
import { createLazyOption } from "owa-options-core";
import { LazyModule, LazyAction } from "owa-bundling";
import { SearchFolderOption_Title, optionSearch_searchFolders, } from "./SearchFoldersOption.locstring.json";
import { getEnterpriseOrPremiumLicenseStatus } from "owa-has-enterprise-or-premium-license-store";

const lazyModule: LazyModule<typeof lazyFullOption> = new LazyModule<typeof lazyFullOption>(() => import("./lazyFullOption"), {
    name: "SearchFoldersOption",
});

const SearchFoldersOption: LazyOption = createLazyOption({
    key: "SearchFolders",
    titleStringKey: SearchFolderOption_Title,
    isTitleHidden: () => true,
    searchTermsStringKey: optionSearch_searchFolders,
    isHidden: () => {
        return getEnterpriseOrPremiumLicenseStatus() != "HasEnterpriseOrPremiumLicense";
    },
    copilotSettingKey: "searchfolders",
}, lazyModule, m => m.default);

export const lazyEditSearchFolderOption: LazyAction<typeof lazyFullOption.editSearchFolder, typeof lazyModule> = new LazyAction(lazyModule, m => m.editSearchFolder);

export const lazyCreateSearchFolder: LazyAction<typeof lazyFullOption.createSearchFolder, typeof lazyModule> = new LazyAction(lazyModule, m => m.createSearchFolder);

export default SearchFoldersOption;
